/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { teamRefSchema } from './teamRefSchema';

export const paginatedResultTeamRefSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(teamRefSchema);
  },
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
  totalCount: z.int().nullish(),
});
